<template>
  <div class="text-input-root" :class="containerClass">
    <div
      class="text-input-container"
      :style="inputStyle"
      :class="{ error: error }"
    >
      <label class="text-input-label" :for="name" :class="{ shrink }">
        {{ label }}<span v-if="required" class="text-input-asterisk">*</span>
      </label>

      <component
        :is="type === 'textarea' ? 'textarea' : 'input'"
        class="text-input"
        :name="name"
        :type="type"
        :maxlength="maxlength"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @focus="handleFocus"
        @blur="
          $emit('blur', $event.target.value);
          isFocused = false;
        "
      />
    </div>

    <div class="text-input-error" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "text-input",
  data() {
    return {
      isFocused: false,
    };
  },
  computed: {
    shrink() {
      if (this.isFocused || this.value.length > 0) {
        return true;
      }

      return false;
    },
  },
  props: {
    containerClass: String,
    inputStyle: Object,
    error: [String, Boolean],
    label: String,
    maxlength: [String, Number],
    name: {
      type: String,
      required: true,
    },
    required: Boolean,
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
  },
  methods: {
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
    },
  },
};
</script>
